exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-analytics-collection-analytics-header-styles__header {\n  display: flex;\n  justify-content: center;\n  border-bottom: 0;\n}\n\n.src-analytics-collection-analytics-header-styles__headerItems {\n  cursor: pointer;\n  padding-left: 1.6rem;\n  padding-right: 1.6rem;\n  margin-right: 0.8rem;\n  font-size: 1.3rem;\n  height: 5.2rem;\n  padding-top: 18px;\n  color: var(--cps-color-primary-text);\n}\n\n.src-analytics-collection-analytics-header-styles__headerItems:hover {\n  text-decoration: none;\n  color: var(--cps-color-monsoon);\n}\n", ""]);

// exports
exports.locals = {
	"header": "src-analytics-collection-analytics-header-styles__header",
	"headerItems": "src-analytics-collection-analytics-header-styles__headerItems"
};